import React from "react";
import Styles from "./VerifiedPopup.module.css";
import { Modal } from "@mui/material";
import { ReactComponent as Tick } from "../../../../assets/images/Tick.svg";

const VerifiedPopup = ({ open, handleClose }) => {
  return (
    <>
      <Modal open={open} onClose={handleClose} aria-labelledby="success-popup">
        <div className={Styles.popupModelContainerReg}>
          <div className={Styles.popUpContentReg}>
            <div className={Styles.popUpContentTextReg}>
              <span className={Styles.regSpan}>
                Access to the Dashboard and Listing function is
                <span className={Styles.boldText}>
                  {" "}
                  restricted temporarily as account verification is in progress.
                </span>
              </span>{" "}
              Review status in 24-48 hours.
            </div>
          </div>
          <div className={Styles.popModelSubContainer}>
            <div className={Styles.popHeadingReg}>
              For any urgent requests, please write to
              <span className={Styles.popUpSpan}>admin@gna.energy</span>
            </div>
          </div>
          <div className={Styles.popUpConfirmationReg}>
            <div className={Styles.okConfirmation} onClick={handleClose}>
              OK
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default VerifiedPopup;
